'use client';

import { useEffect } from 'react';
import { T } from '@/i18n/LocaleProvider';
import { sendGTMEvent } from '@/utils/analytics';
import { GTM_EVENTS } from '@/constants/gtm';
import { demoCTA } from '@/libs/cta';
import styles from './Agenda.module.scss';

// Espera máxima al GTM antes de redirigir: si GTM no cargó (sin consentimiento), no hay nada que esperar.
const ESPERA_MS = 1200;

// El origen del clic: `?from=instagram` (o `utm_source`). Sin ninguno, «directo».
function origen(search) {
  const p = new URLSearchParams(search);
  return (p.get('from') || p.get('utm_source') || 'directo').toLowerCase().replace(/[^a-z0-9_.-]/g, '').slice(0, 40) || 'directo';
}

/**
 * /agenda: registra `demo_request` con su origen y redirige al calendario. Un redirect de servidor (el
 * 302 de antes) no deja rastro en GA4; esta página sí. `eventCallback` redirige apenas GTM termina de
 * disparar las etiquetas, con `ESPERA_MS` como tope. Sin JavaScript queda el enlace.
 */
export default function AgendaRedirect() {
  useEffect(() => {
    let hecho = false;
    const ir = () => {
      if (hecho) return;
      hecho = true;
      window.location.replace(demoCTA.url);
    };
    sendGTMEvent({
      event: GTM_EVENTS.DEMO_REQUEST,
      source: origen(window.location.search),
      cta_label: 'agenda',
      eventCallback: ir,
      eventTimeout: ESPERA_MS,
    });
    const t = setTimeout(ir, ESPERA_MS);
    return () => clearTimeout(t);
  }, []);

  return (
    <div className={styles.page}>
      <p className={styles.text}>
        <T>Abriendo la agenda…</T>
      </p>
      <a className={styles.link} href={demoCTA.url}>
        <T>Si no se abre, haz clic aquí</T>
      </a>
    </div>
  );
}
